type AnimationDescription = [() => void, number];

type CancelFunction = () => void;

function executeAnimationDescription(
	animationDescription: AnimationDescription,
	callback: () => void,
): ReturnType<typeof setTimeout> {
	return setTimeout(() => {
		animationDescription[0]();
		callback();
	}, animationDescription[1]);
}

export default function scheduleAnimation(
	animationDescriptions: AnimationDescription[],
): CancelFunction {
	let currentAnimationId: ReturnType<typeof setTimeout> | null = null;
	let remainingAnimationDescriptions = [...animationDescriptions];

	const handleNextAnimation = (): void => {
		currentAnimationId = null;

		if (remainingAnimationDescriptions.length) {
			const nextAnimationDescription = remainingAnimationDescriptions[0];
			remainingAnimationDescriptions = remainingAnimationDescriptions.slice(1);
			currentAnimationId = executeAnimationDescription(
				nextAnimationDescription,
				handleNextAnimation,
			);
		}
	};

	handleNextAnimation();

	return (): void => {
		if (currentAnimationId) {
			clearTimeout(currentAnimationId);
			remainingAnimationDescriptions = [];
			currentAnimationId = null;
		}
	};
}
